/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type PropertyInCalendarMapping = typeof PropertyInCalendarMapping[keyof typeof PropertyInCalendarMapping] | null;


export const PropertyInCalendarMapping = {
  event_title: 'event_title',
  attendee: 'attendee',
} as const;
